import { Typography } from "@mui/material";
import { useEffect, useState } from "react";

const getCurrentTimeInSeconds = () => {
  return new Date().getTime() / 1000;
};

const getTwoDigits = (n: number) => {
  if (n > 9) {
    return n;
  } else if (n < 0) {
    return n;
  }
  return `0${n}`;
};

function secondsToDhms(seconds: number) {
  seconds = Number(seconds);
  const d = Math.floor(seconds / (3600 * 24));
  const h = Math.floor((seconds % (3600 * 24)) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  return (
    (d > 0 ? `${d}д ` : " ") +
    `${getTwoDigits(h)}:${getTwoDigits(m)}:${getTwoDigits(s)}`
  );
}

export const TimerCountDown = ({
  endAtTimeStamp,
}: {
  endAtTimeStamp?: number;
}) => {
  const [remainsInSec, setRemainsInSec] = useState(
    endAtTimeStamp ? endAtTimeStamp - getCurrentTimeInSeconds() : 0
  );

  useEffect(() => {
    remainsInSec > 0 &&
      setTimeout(() => setRemainsInSec(remainsInSec - 1), 1000);
    if (remainsInSec < 0) {
      setRemainsInSec(0);
    }
  }, [remainsInSec]);

  if (!endAtTimeStamp) return null;
  return (
    <Typography
      fontSize={"inherit"}
      color={"inherit"}
      sx={{
        whiteSpace: "nowrap;",
      }}
    >
      {secondsToDhms(remainsInSec)}
    </Typography>
  );
};
